Vue.asyncComponent('ak-toasts', {
    props: {
        messages: {
            type: Array,
        }
    }
}, 'layout/ak-toasts.html');